/**
 * Created by muratzengin on 27/03/16.
 */
import {Injectable} from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class InboundNotificationService {
    private subject = new Subject<any>();
    private filterBoxSubject = new Subject<any>();

    public notifyFilterBoxAddressChange(message: boolean) {
      this.filterBoxSubject.next(message);
    }

    public getFilterBoxAddressChangeNotifications(): Observable<any> {
      return this.filterBoxSubject.asObservable();
    }

    public notify(message: boolean) {
        this.subject.next(message);
    }

    public getNotifications(): Observable<any> {
        return this.subject.asObservable();
    }
}
